// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-0ecf7726]{color:#02c3cc}.visual-box[data-v-0ecf7726]{background:#fff;z-index:10;box-shadow:-14px 10px 30px rgba(16,11,73,.08)}.home-phone[data-v-0ecf7726]{top:100px;left:-320px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
